import React from 'react'

import { ConfigureToolFormInputs } from './ConfigureToolFormInputs'
import { ToolInputTableAccess } from './ToolInputTableAccess'
import { ConfigureToolProps } from './types'

export const ConfigureQueryRecordsTool: React.FC<ConfigureToolProps> = ({ tool }) => {
    return (
        <>
            <ToolInputTableAccess />
            <ConfigureToolFormInputs inputs={tool.inputs} />
        </>
    )
}
